import { UserProfileDto } from '../modules/users/types/UserProfileDto'

import { SelectField } from './SelectField'

const SelectUserField: React.FC<{
  label: string
  name: string
  value?: string
  options: UserProfileDto[] | undefined
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  errors?: { [key: string]: string }
}> = ({ label, name, value, options, handleInputChange, errors }) => {
  // Convert array to record
  const optionsRecord: Record<string, string> = (options ?? []).reduce(
    (acc, option) => {
      acc[option.profile._id] = `${option.user.firstname} ${option.user.lastname}`

      return acc
    },
    {} as Record<string, string>
  )

  return (
    <div>
      <SelectField
        label={label}
        name={name}
        value={value}
        options={optionsRecord}
        handleInputChange={handleInputChange}
        errors={errors}
      />
    </div>
  )
}
export default SelectUserField
